module.exports = __webpack_public_path__ + "b8a101766810d3791c42d7ecb1c8684e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-12.png
// module id = 1997
// module chunks = 0